import { AuthorizationWrapper } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';
import { Feature, Functionality } from '@frontend/functionality/types';
import { getFunctionalityDisplayName } from '@frontend/functionality/utils';
import { useAccountRepository } from '@frontend/repository';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';

import useLicensedNavbarItem from './licensed-navbar-item.controller';

const ID = 'licensed-navbar-item';
export interface LicensedNavbarItemProps {
    functionality: Functionality;
}

const LicensedNavbarItem = (props: LicensedNavbarItemProps) => {
    const viewProps = useLicensedNavbarItem(props);
    const intl = useIntl();
    const { currentAccount } = useAccountRepository();
    const functionalitySearch = `?functionalityId=${props.functionality.id}`;
    // Licenses may still emit feature "shared"; hide the dead nav item after role-share removal.
    if ((props.functionality.feature as string) === 'shared') {
        return null;
    }

    const content = (
        <NavLink
            id={ID + '_' + props.functionality.id}
            to={{ pathname: viewProps.link, search: functionalitySearch }}
            state={{ functionalityId: props.functionality.id }}
            className='group flex w-full items-center justify-start self-stretch pl-4.5'>
            {({ isActive }) => (
                <div
                    data-testid='licensed-navbar-item-pill'
                    className={`flex min-h-9 w-full items-center overflow-hidden rounded-r-md ${
                        isActive ? 'bg-brand-light text-brand-primary' : 'text-foreground-default group-hover:bg-brand-light/60'
                    }`}>
                    <div className={`w-1 shrink-0 self-stretch ${isActive ? 'bg-brand-accent' : 'bg-background-default group-hover:bg-brand-accent'}`} />
                    <div className='justify-center px-2.5 text-base font-medium'>
                        {viewProps.expanded && <span className='text-nowrap'>{getFunctionalityDisplayName(intl, props.functionality)}</span>}
                    </div>
                </div>
            )}
        </NavLink>
    );

    if (props.functionality.feature === Feature.ROLES) {
        return (
            <AuthorizationWrapper
                showLoading={false}
                requiredPermissions={[{ item: EntityType.ROLE, source: EntityType.ACCOUNT, right: Rights.READ, uid: currentAccount! }]}>
                {content}
            </AuthorizationWrapper>
        );
    }

    return content;
};

export default LicensedNavbarItem;
